import { createTranslations } from '@npco/common-utils-translations'

export const savingsStageTranslations = createTranslations({
  title: 'Access your money instantly',
  description:
    "You can transfer funds in and out of a Zeller Savings Account instantly. There are no commitments or lock-in periods, so you'll have access to your money whenever you need it.",
})
